import { DayPerformance } from 'types';
import { Heading, Text } from 'components';
import { formatTimestamp } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface Props {
  daysPerformance: DayPerformance[];
}

export function ServiceChart({ daysPerformance }: Props) {
  const biggerSize = daysPerformance.reduce((acc, day) => {
    const { confirmedQuantity, revokedQuantity } = day;
    const sum = confirmedQuantity + revokedQuantity;

    return sum > acc ? sum : acc;
  }, 0);

  return (
    <S.Main>
      <Heading size={FontSize.font24} className="title">
        Performance por dia
      </Heading>

      <div className="container">
        <S.Wrapper>
          {daysPerformance.map((dayPerformance) => {
            const { date, confirmedQuantity, revokedQuantity } = dayPerformance;

            const { day, month } = formatTimestamp(date);
            const revokedQuantitySize = (revokedQuantity * 100) / biggerSize;
            const confirmedQuantitySize =
              (confirmedQuantity * 100) / biggerSize;

            return (
              <S.BarWrapper key={date.toString()}>
                <S.BarContainer>
                  {Boolean(revokedQuantity) && (
                    <S.Bar
                      $isZero={revokedQuantity === 0}
                      $size={revokedQuantitySize}
                    >
                      <S.TextWrapper>
                        <Text
                          size={FontSize.font12}
                          weight={FontWeight.bold}
                          className="bar-text"
                        >
                          {revokedQuantity}
                        </Text>
                      </S.TextWrapper>
                    </S.Bar>
                  )}

                  {Boolean(confirmedQuantity || !revokedQuantity) && (
                    <S.Bar
                      $isZero={confirmedQuantity === 0}
                      $approved
                      $size={confirmedQuantitySize}
                    >
                      <S.TextWrapper>
                        <Text
                          size={FontSize.font12}
                          weight={FontWeight.bold}
                          className="bar-text"
                        >
                          {confirmedQuantity}
                        </Text>
                      </S.TextWrapper>
                    </S.Bar>
                  )}
                </S.BarContainer>

                <Text className="bar-wrapper-text" size={FontSize.font12}>
                  {day}/{month}
                </Text>
              </S.BarWrapper>
            );
          })}
        </S.Wrapper>
      </div>
    </S.Main>
  );
}
